import React from 'react';
import { gsap, Expo } from 'gsap';
import PropTypes from 'prop-types';
// import useMedia from '../../../../hooks/useMedia';
import useLanguage from '../../../../hooks/useLanguage';

const ArticleMainScreen = ({ mainData, category  }) => {
  const langToggle = useLanguage;

  // const isBig = useMedia('(max-width: 1399.98px) and (min-width: 991.98px)');
  // const isMedium = useMedia('(max-width: 991.98px) and (min-width: 767.98px)');
  // const isSmall = useMedia('(max-width: 767.98px)');

  const title = langToggle(mainData.title_ua, mainData.title_ru);

  let words = title.split('\n');

  const [tl] = React.useState(gsap.timeline({ paused: false }));

  let categoryElement = React.useRef(null);
  let titleElement = React.useRef([]);
  let subTitleElement = React.useRef(null);

  React.useEffect(() => {
    tl.to(categoryElement, 1.5, {
      y: 0,
      opacity: 1,
      ease: Expo.easeOut,
      delay: 3.5,
    })
      .staggerTo(
        titleElement.current,
        1.5,
        { y: 0, opacity: 1, ease: Expo.easeOut, delay: -1.25 },
        0.2
      )
      .to(subTitleElement, 1.5, {
        y: 0,
        opacity: 1,
        ease: Expo.easeOut,
        delay: -1.25,
      });
  }, [tl, words]);

  return (
    <section id="top-section" className="aricle-main" data-scroll-section>
      <div className="article-main__center">
        <div className="article-main__category-wrapper">
          <span
            className="article-main__category"
            ref={(e) => (categoryElement = e)}
          >
            {langToggle(category.title_ua, category.title_ru)}
          </span>
        </div>
        <h1
          className="aricle-main__title"
          data-scroll=""
          data-scroll-speed="-1"
          data-scroll-delay="0.05"
        >
          {words.map((word, i) => {
            const speed = i === 0 ? '2' : i === 1 ? '1.5' : '1';

            if (word === ' ') {
              return (
                <span
                  className="article-main__title-word__wrapper"
                  key={i}
                  id={i}
                  data-scroll=""
                  data-scroll-speed={speed}
                  data-scroll-delay="0.05"
                >
                  <span
                    className="article-main__title-word"
                    ref={(e) => (titleElement.current[i] = e)}
                  >
                    &nbsp;
                  </span>
                </span>
              );
            } else {
              return (
                <span
                  className="article-main__title-word__wrapper"
                  key={i}
                  id={i}
                  data-scroll=""
                  data-scroll-speed={speed}
                  data-scroll-delay="0.05"
                >
                  <span
                    className="article-main__title-word"
                    ref={(e) => (titleElement.current[i] = e)}
                  >
                    {word + (i !== words.length - 1 ? '\u00A0' : '')}
                  </span>
                </span>
              );
            }
          })}
        </h1>
        <div className="article-main__subtitle-wrapper">
          <span
            className="article-main__subtitle"
            ref={(e) => (subTitleElement = e)}
          >
            <span className="article-main__subtitle-time">
              {langToggle(mainData.time_ua, mainData.time_ru)}
            </span>
            <span className="article-main__subtitle-slash">{' / '}</span>
            <span className="article-main__subtitle-date">{mainData.date}</span>
          </span>
        </div>
      </div>
    </section>
  );
};

ArticleMainScreen.propTypes = {
  mainData: PropTypes.object,
};

export default ArticleMainScreen;
